import { LinearGradient } from 'expo-linear-gradient';
import { setLinearGradientComponent } from './LinearGradient';
setLinearGradientComponent(LinearGradient);

export type { LinearGradientPoint, LinearGradientProps } from './LinearGradient';
export { MotionLinearGradient } from './LinearGradient';
